import './draggableTab.css';
import { DndContext, PointerSensor, useSensor } from '@dnd-kit/core';
import {
  arrayMove,
  horizontalListSortingStrategy,
  SortableContext,
  useSortable,
} from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import React, { useEffect, useRef, useState } from 'react';
import { Tabs, Popover, Input, Button, Spin, Dropdown, Space } from 'antd';
import { CaretDownFilled } from '@ant-design/icons';
import dragimg from '@src/assets/img/draggable.svg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose, faWarning } from '@fortawesome/free-solid-svg-icons';
import { faAdd, faSearch } from '@fortawesome/free-solid-svg-icons';
import { CreateView } from './modal/createView.modal';
import { useMutation, useQuery } from '@apollo/client';
import { useDispatch } from 'react-redux';
import { resetAdvanceFilter, resetQuickFilter, setAdvanceFilter, setQuickFilter } from '@src/middleware/redux/reducers/quickFilter';
import { useSelector } from 'react-redux';
import { resetAll } from '@src/middleware/redux/reducers/reset.reducer';
import { setTogglenewCreateView } from '@src/middleware/redux/reducers/newView.reducer';
import { createdDateList } from "@src/util/date";
import { upsertUserAllViewMutation } from '@src/util/mutation/userAllView.mutation';
import { getUserAllViewQuery } from '@src/util/query/userAllView.query';
import { AllView, CreateView as ViewActionModal } from "@src/components/allView/allView.component";
import { setNotification } from '../../middleware/redux/reducers/notification.reducer';
import { LockedViewIcon } from './lockedViewIcon';



export const DraggableTabNode = ({ className, ...props }) => {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({
    id: props['data-node-key'],
  });
  const style = {
    ...props.style,
    transform: CSS.Transform.toString(
      transform && {
        ...transform,
        scaleX: 1,
      },
    ),
    transition,
    cursor: 'pointer',
  };
  return React.cloneElement(props.children, {
    ref: setNodeRef,
    style,
    ...attributes,
    ...listeners,
  });
};

const DraggableTab = ({viewList=[], refetch, loading,
  updateView, createViewLoading, createView, addNewViewHide=false, objectType="", openAllView,
  deleteView, cloneView, setActiveView=()=>{}, openAllViewAction=()=>{}, closeAllViewAction=()=>{},
  setIsViewChanged=()=>{},
  // this is for when we do need to show loader icon on changing the view
  setDataLoading=()=>{},
}) => {

  const {authenticatedUserDetail} = useSelector(state=>state.userAuthReducer);   
  const [upsertUserViewList, {loading: upsertUserViewListLoading}] = useMutation(upsertUserAllViewMutation); 



  const [items, setItems] = useState([]);

  const popoverRef = useRef();
  const inputRef = useRef();
  const preventPopoverCloseRef = useRef(false);
  const triggerBtnRef = useRef();
  const [popoverMarginLeft, setPopoverMarginLeft] = useState(20);

  const [activeKey, setActiveKey] = useState();
  const [createViewForm, setCreateViewForm] = useState(false);
  const [view, setView] = useState([]);
  const [viewSearch, setViewSearch] = useState();
  const [selectedView, setSelectedView] = useState('');
  const [viewPop, setViewPop] = useState();
  const [createdView, setCreatedView] = useState([]);
  const [otherView, setOtherView] = useState([]);
  
  const dispatch = useDispatch();

  const [pinView, setPinView] = useState();
  const [allViewModal, setAllViewModal] = useState(false);
  const [actionView, setActionView] = useState(null);
  const [viewActionModal, setViewActionModal] = useState(false);
  const [openDropdownId, setOpenDropdownId] = useState(null);

  const [newView, setNewView] = useState(false);
  const [loadingTabKey, setLoadingTabKey] = useState(null);

  // Wrap setDataLoading so clearing it also clears the tab spinner
  const handleSetDataLoading = (val) => {
    setDataLoading(val);
    if (!val) setLoadingTabKey(null);
  };



  const handelDeleteView = async (view) => {
    const confirmed = window.confirm("Do you really want to delete this view?");
    if (!confirmed) return;
    await deleteView({ variables: { id: view?._id } });
    dispatch(setNotification({ error: false, notificationState: true, message: "View was deleted successfully" }));
    sessionStorage.removeItem("selectedViewId");
    setActionView(null);
    await refetch();
  };

  const openViewAction = (datelist, action) => {
    setOpenDropdownId(null);
    setActionView({...datelist, action});
    setViewActionModal(true);
  };

  const holdPopover = () => { preventPopoverCloseRef.current = true; };

  const getStandardViewItems = (datelist) => [
    { key: '1', label: <div className="view-menuitem" onMouseDown={holdPopover} onClick={(e) => { e.stopPropagation(); openViewAction(datelist, 'clone'); }}>Clone</div> },
    // { key: '2', label: <div className="view-menuitem">Export</div> },
  ];

  const getMyViewItems = (datelist) => [
    { key: '1', label: <div className="view-menuitem" onMouseDown={holdPopover} onClick={(e) => { e.stopPropagation(); setOpenDropdownId(null); handelDeleteView(datelist); }}>Delete</div> },
    { key: '2', label: <div className="view-menuitem" onMouseDown={holdPopover} onClick={(e) => { e.stopPropagation(); openViewAction(datelist, 'sharing'); }}>Manage Sharing</div> },
    { key: '3', label: <div className="view-menuitem" onMouseDown={holdPopover} onClick={(e) => { e.stopPropagation(); openViewAction(datelist, 'rename'); }}>Rename</div> },
    { key: '4', label: <div className="view-menuitem" onMouseDown={holdPopover} onClick={(e) => { e.stopPropagation(); openViewAction(datelist, 'clone'); }}>Clone</div> },
    // { key: '5', label: <div className="view-menuitem">Export</div> },
  ];

  // add new view in pinned list
  const handelSelectedView = async(prop)=>{
    handleSetDataLoading(true);
    setLoadingTabKey(prop?.id?.toString() || prop?._id?.toString());
    setAllViewModal(false);

    // dispatch(resetAll());
    const selectedSingleView = viewList?.find((view)=>view._id==prop.id);
    const isExist = items.find((item)=>item._id==prop._id);

    sessionStorage.setItem("selectedViewId", prop?._id);
    setActiveView(prop?._id);

    if(!isExist){
      if(items?.length<5){
        if(objectType?.length>0 && authenticatedUserDetail?._id){
          const updatedItem = [...items, {_id: prop._id?.toString()}]?.map((item, order)=>({viewId: item?._id?.toString(), order: order.toString(), isPinned: true }))?.filter((view)=>view?.viewId)
          await upsertUserViewList({
            variables:{
              input:{
                userId: authenticatedUserDetail?._id,
                objectType,
                viewDetail: updatedItem,
              }
            }
          });
        }
        setItems([...items, {key: prop.id, label: selectedSingleView?.name, ...selectedSingleView}]);
        setNewView(prop?.id);
        await refetch();
        await refetchUserAllView();
        
      }else{
        setItems([...items.slice(0,4), {key: prop.id, label: selectedSingleView?.name, ...selectedSingleView}])
        setNewView(prop?.id);
      }
    }else{
      setActiveKey(isExist.key.toString());
    }

    if(selectedSingleView?.quickFilter){
      const quickFilter = {}
      
      if(selectedSingleView?.quickFilter?.createdDate && Object.values(selectedSingleView?.quickFilter?.createdDate)?.length>0){
        quickFilter['createdDate']={
          title: selectedSingleView?.quickFilter?.createdDate?.title,
          value: createdDateList?.find((date)=>date?.title==selectedSingleView?.quickFilter?.createdDate?.title)?.value
        }
      }

      if(selectedSingleView?.quickFilter?.updatedDate && Object.keys(selectedSingleView?.quickFilter?.updatedDate)?.length>0){
        quickFilter['updatedDate']={
          title: selectedSingleView?.quickFilter?.updatedDate?.title,
          value: createdDateList?.find((date)=>date?.title==selectedSingleView?.quickFilter?.updatedDate?.title)?.value
        }
      }

      dispatch(setQuickFilter(quickFilter));
    }else{
      dispatch(resetQuickFilter());
    }
    if(selectedSingleView?.advanceFilter && selectedSingleView?.advanceFilter?.length>0){
      dispatch(setAdvanceFilter(selectedSingleView?.advanceFilter));
    }else{
      dispatch(resetAdvanceFilter());
    }

  };


  const {data:userAllViewList, loading:userAllViewListLoading, refetch: refetchUserAllView} = useQuery(getUserAllViewQuery,{
    variables:{
      userId: authenticatedUserDetail?._id,
      objectType
    },
    fetchPolicy:'network-only',
    skip: !authenticatedUserDetail?._id || objectType?.length==0
  })

    // Also clear tab spinner when both async loading states settle
    useEffect(() => {
      if (!userAllViewListLoading && !upsertUserViewListLoading && loadingTabKey !== null) {
        setLoadingTabKey(null);
      }
    }, [userAllViewListLoading, upsertUserViewListLoading]);

  // handel to active new view

  useEffect(()=>{
    if(newView){
      setActiveKey((newView).toString());
      setSelectedView((newView).toString())
      setPinView((newView).toString())
      setNewView(false);
    }
  },[newView, items]);
 




  // load all pinned view from user views
  useEffect(()=>{
    if(viewList && userAllViewList && !userAllViewListLoading && !loading){
      
      
      const orderedViewIds = userAllViewList?.getUserAllViewList?.response?.viewDetail?.map((ov)=>ov?.viewId);
      
      const orderedViews = (orderedViewIds?.map((ov)=> viewList?.find((vl)=>vl?._id==ov))?.filter(Boolean)) || [];
    

      setItems(
        orderedViews?.map((list, index)=>({...list, key: list?._id, label:list?.name, id: list?._id}))
      );
      
      // a locked view is a shared standard one (WFC360's own) - listed under Standard
      setView(viewList?.filter((view)=> view?.isStandard || view?.locked)?.map((list, index)=>({...list, key: list._id, label:list.name, id: list._id})));
      
      setCreatedView(
        viewList?.filter((view)=> view?.createdBy==authenticatedUserDetail?._id && !view?.isStandard && !view?.locked)?.map((list, index)=>({key: list._id, label:list.name, id: list._id, ...list}))
      );

      setOtherView(
        viewList?.filter((view)=> view?.createdBy!==authenticatedUserDetail?._id && !view?.isStandard && !view?.locked)?.map((list, index)=>({key: list._id, label:list.name, id: list._id, ...list}))
      );

      if(!sessionStorage.getItem('selectedViewId') || !orderedViews?.find((view)=>view?._id===sessionStorage.getItem('selectedViewId'))){

        sessionStorage.setItem("selectedViewId", orderedViews[0]?._id);
        setActiveView(orderedViews[0]?._id);
      
        // Handel page load first time to active tab

        // dispatch(resetAll());
        setActiveKey(orderedViews[0]?._id);
        setPinView(orderedViews[0]?._id);

        if( orderedViews[0]?.quickFilter && Object.values(orderedViews[0]?.quickFilter).length>0){

          const filter = {
            createdDate: orderedViews[0]?.quickFilter?.createdDate && Object.values(orderedViews[0]?.quickFilter?.createdDate)?.length>0?{
              ...orderedViews[0]?.quickFilter?.createdDate,
              value: createdDateList?.find((date)=>date?.title==orderedViews[0]?.quickFilter?.createdDate?.title)?.value
            } : {},
            updatedDate: orderedViews[0]?.quickFilter?.updatedDate && Object.values(orderedViews[0]?.quickFilter?.updatedDate)?.length>0?{
              ...orderedViews[0]?.quickFilter?.updatedDate,
              value: createdDateList?.find((date)=>date?.title==orderedViews[0]?.quickFilter?.updatedDate?.title)?.value
            }:{}
          }
          dispatch(setQuickFilter(filter));
        }else{
          dispatch(resetQuickFilter());
          dispatch(setQuickFilter([]));

        }
        if(orderedViews[0]?.advanceFilter && orderedViews[0]?.advanceFilter?.length>0){
          dispatch(setAdvanceFilter(orderedViews[0]?.advanceFilter));
        }else{
          dispatch(resetAdvanceFilter());
          dispatch(setAdvanceFilter([]));

        }
      }

    }
  },[viewList, userAllViewList?.getUserAllViewList?.response, userAllViewListLoading, loading])



  useEffect(()=>{
    if(sessionStorage.getItem("selectedViewId")){
      setActiveKey(sessionStorage.getItem("selectedViewId"));
    }
  },[sessionStorage.getItem("selectedViewId")]);


  const sensor = useSensor(PointerSensor, {
    activationConstraint: {
      distance: 100,
    },
  });


  // rearrange the order of pinned views in userViewList based on objectType e.g; Site, Employee, Branch
  const onDragEnd = ({ active, over }) => {
    if (active.id !== over?.id) {
      setItems((prev) => {
        const activeIndex = prev.findIndex((i) => i.key === active.id);
        const overIndex = prev.findIndex((i) => i.key === over?.id);
        const finalItems = arrayMove(prev, activeIndex, overIndex);
        if(objectType?.length>0 && authenticatedUserDetail?._id){
          upsertUserViewList({
            variables:{
              input:{
                userId: authenticatedUserDetail?._id,
                objectType,
                viewDetail: finalItems?.map((item, order)=>({viewId: item?._id.toString(), order: order.toString(), isPinned: true })),
              }
            }
          })
        }
        return arrayMove(prev, activeIndex, overIndex);
      });
      refetchUserAllView();
      refetch();
    }
  };




  // on unPin we do remove the view from UserViewList
  const removeView = async (rmItm) => {
    try{

      handleSetDataLoading(true);
      const filtered = items?.filter(item=>item.key!=rmItm.key);
      setItems(filtered);
      await refetch();
      if(objectType?.length>0 && authenticatedUserDetail?._id){
        await upsertUserViewList({
          variables:{
            input:{
              userId: authenticatedUserDetail?._id,
              objectType,
              viewDetail: filtered?.map((item, order)=>({viewId: item?._id.toString(), order: order.toString(), isPinned: true })),
            }
          }
        });
        await refetchUserAllView();
      }
  
      const islastKeyExist = filtered[0]?.key;
      if(islastKeyExist){
        setLoadingTabKey(islastKeyExist.toString());
        handelActiveTab(islastKeyExist);
      }

    }catch(err){

    }finally{
      handleSetDataLoading(false);
    }


  };


  const handelActiveTab = (e)=>{
    handleSetDataLoading(true);
    setLoadingTabKey(e?.toString());
    // dispatch(resetAll());
    setActiveKey(e);
    setPinView(e.toString());
    const selectedView = items?.find((view)=>view.key==e.toString());
    
    // dispatch(setSelectedViewId(selectedView?._id));
    sessionStorage.setItem("selectedViewId", selectedView?._id);
    setActiveView(selectedView?._id);
    
    if(selectedView?.quickFilter && Object.values(selectedView?.quickFilter).length>0){

      const filter = {
        createdDate:{
          ...selectedView?.quickFilter?.createdDate,
          value: createdDateList?.find((date)=>date?.title==selectedView?.quickFilter?.createdDate?.title)?.value
        },
        updatedDate:{
          ...selectedView?.quickFilter?.updatedDate,
          value: createdDateList?.find((date)=>date?.title==selectedView?.quickFilter?.updatedDate?.title)?.value
        }
      }
      dispatch(setQuickFilter(filter));

    }else{
      dispatch(resetQuickFilter());
    }
    if(selectedView?.advanceFilter && selectedView?.advanceFilter?.length>0){
      dispatch(setAdvanceFilter(selectedView?.advanceFilter));
    }else{
      dispatch(resetAdvanceFilter());
    }
  };

  // toggle create view from save as option in save btn
  const {togglenewCreateView} = useSelector(state=>state.newViewReducer);

  // popover search filters all three groups (Standard, Created by me, Created by Others)
  const viewSearchTerm = viewSearch?.trim()?.toLowerCase();
  const matchesViewSearch = (v) => !viewSearchTerm || v?.name?.toLowerCase()?.includes(viewSearchTerm);
  const filteredView = view?.filter(matchesViewSearch);
  const filteredCreatedView = createdView?.filter(matchesViewSearch);
  const filteredOtherView = otherView?.filter(matchesViewSearch);


  useEffect(()=>{
    setIsViewChanged(true);
  },[activeKey, newView]);
  

  return (
    <>
      <div
        className='setting-body-inner grid-tabs' style={{
          padding: '12px 48px 0px', 
          display: 'flex', alignItems:'center'
        }}
      >
        <Tabs       
          closeIcon={true}
          onChange={(e)=>handelActiveTab(e)}
          renderTabBar={(tabBarProps, DefaultTabBar) => (
            <DndContext sensors={[sensor]} onDragEnd={onDragEnd}>
              <SortableContext items={items.map((i) => i.key)} strategy={horizontalListSortingStrategy}>
                <DefaultTabBar {...tabBarProps}>
                  {(node) => (
                    <DraggableTabNode {...node.props} key={node.key}>
                      {node}
                    </DraggableTabNode>
                  )}
                </DefaultTabBar>
              </SortableContext>
            </DndContext>
          )}
          activeKey={activeKey}
        >
          {items?.map((item, index)=>(

            <Tabs.TabPane  tab={

                <div className='dragContent' style={userAllViewListLoading || upsertUserViewListLoading || createViewLoading ? {opacity:0.3}:{opacity:1}}>
                  {/* {loadingTabKey === item?.key?.toString() && (
                    <Spin size="small" style={{ marginRight: 6 }} />
                  )} */}
                  {items?.length>1?
                  <>
                    {index>4?
                    <Popover
                      content={"You have hit the limit of open views."}
                    >
                      <FontAwesomeIcon icon={faWarning} style={{color: 'orange', margin: '0 10px'}} />
                    </Popover>
                    : 
                    <img src={dragimg} alt="" className='dragimg'/> 
                    }
                    
                    
                    <div style={{width:'100%', display:'flex', justifyContent:'space-between', alignItems:'center'}}> {item.label} {item.locked && <LockedViewIcon/>} </div> 
                       

                    

                    {
                      addNewViewHide? null :
                      <FontAwesomeIcon 
                        style={{marginLeft:'15px',marginRight:'-15px'}} 
                        className={pinView==item.key?'':'dragimg'} icon={faClose} 
                        onClick={()=>removeView(item)}
                      />
                    }
                  </> : 
                  <>
                    {index>4?
                    <FontAwesomeIcon icon={faWarning} />
                    : 
                    <img src={dragimg} alt="" className='dragimg'/> 
                    }
                    <div style={{width:'100%'}}>{item.label} {item.locked && <LockedViewIcon/>}</div>
                  </>
                  }
                </div>

            } key={item?.key} tabKey={item?.key} />

          ))}
        </Tabs>

        
          <div className='addView' style={addNewViewHide?{paddingTop:'33px'}:{}}> 

            {addNewViewHide? null:
              <>
                <Popover
                    open={viewPop}
                    overlayClassName='settingCustomPopover viewPopover'
                    afterOpenChange={(open)=>{ if(open) inputRef.current?.focus(); }}
                    style={{ width: 250,  }}
                    overlayStyle={{marginLeft: `${popoverMarginLeft}px`}}
                    onOpenChange={(visible) => {
                      if (!visible) {
                          if (preventPopoverCloseRef.current) {
                            preventPopoverCloseRef.current = false;
                            return;
                          }
                          setOpenDropdownId(null);
                          // defer closing the popover so the Dropdown's own exit transition
                          // runs first; closing both in the same render orphans the
                          // Dropdown's portal node in document.body (antd/rc-trigger quirk)
                          setTimeout(() => setViewPop(false), 0);
                      }
                    }}
                    content={
                        viewPop?
                        <div ref={popoverRef}>
                            <div className="popover-search" ref={popoverRef}>
                                <Input type="search" 
                                    ref={inputRef}
                                    id="inputSearch"
                                    name='popoverSearch'
                                    style={{ width: '-webkit-fill-available', backgroundColor: 'white'  }} 
                                    className='generic-input-control' 
                                    placeholder="Search..."
                                    autoFocus={viewSearch}
                                    autoComplete="off"
                                    value={viewSearch}
                                    onChange={(e)=> setViewSearch(e.target.value)}
                                    suffix={<FontAwesomeIcon style={{color:'#0091ae'}}  icon={faSearch}/>}
                                />
                            </div>
                            
                            <div style={{display:'flex', margin:12}}>

                                <div 
                                    className="popover-data"  
                                    style={{
                                        width: '275px',
                                        overflow: 'auto',
                                        height: '25vh',
                                    }}          
                                    ref={popoverRef}
                                >
                                    <div
                                        style={{
                                            padding: '8px 1px',
                                            color: 'black',
                                            fontWeight: 600,
                                        }}
                                    >Standard ({filteredView?.length})</div>
                                    {filteredView && filteredView?.map((datelist)=>(

                                        <div
                                            style={{paddingLeft:'10px', display:'flex', alignItems:'center', justifyContent:'space-between', paddingRight:'8px'}}
                                            className={selectedView==datelist.label?
                                            "popoverdataitem popoverdataitem-active": "popoverdataitem"}>
                                            <span style={{flex:1, cursor:'pointer'}} onClick={(e)=>{handelSelectedView(datelist);   setOpenDropdownId(null); setViewPop(false);}}>
                                                {datelist?.label} {datelist?.locked && <LockedViewIcon/>}
                                            </span>
                                            <Dropdown menu={{ items: getStandardViewItems(datelist) }} trigger={["click"]} getPopupContainer={() => document.body} overlayStyle={{ zIndex: 2000 }} open={openDropdownId === datelist._id} onOpenChange={(open) => setOpenDropdownId(open ? datelist._id : null)}>
                                                <span className="link view-option" style={{fontSize:'12px', whiteSpace:'nowrap'}} onClick={(e)=>e.stopPropagation()}>
                                                    Options <CaretDownFilled />
                                                </span>
                                            </Dropdown>
                                        </div>
                                    ))}
                                </div>
                                {createdView?.length>0?
                                <div      
                                    className="popover-data"  
                                    style={{
                                        width: '275px',
                                        overflow: 'auto',
                                        height: '25vh',
                                    }}          
                                    ref={popoverRef}
                                >
                                    <div
                                        style={{
                                            padding: '8px 1px',
                                            color: 'black',
                                            fontWeight: 600,
                                        }}
                                    >Created by me ({filteredCreatedView?.length})</div>
                                    {filteredCreatedView && filteredCreatedView?.map((datelist)=>(

                                        <div
                                            style={{paddingLeft:'10px', display:'flex', alignItems:'center', justifyContent:'space-between', paddingRight:'8px'}}
                                            className={selectedView==datelist.label? "popoverdataitem popoverdataitem-active": "popoverdataitem"}>
                                            <span style={{flex:1, cursor:'pointer'}} onClick={(e)=>{handelSelectedView(datelist); setOpenDropdownId(null); setViewPop(false); }}>
                                                {datelist.label} 
                                                <div className="view-body-subtitle">
                                                  {datelist?.visibility}
                                                </div>
                                            </span>
                                            
                                            <Dropdown menu={{ items: getMyViewItems(datelist) }} trigger={["click"]} getPopupContainer={() => document.body} overlayStyle={{ zIndex: 2000 }} open={openDropdownId === datelist._id} onOpenChange={(open) => setOpenDropdownId(open ? datelist._id : null)}>
                                                <span className="link view-option" style={{fontSize:'12px', whiteSpace:'nowrap'}} onClick={(e)=>e.stopPropagation()}>
                                                    Options <CaretDownFilled />
                                                </span>
                                            </Dropdown>
                                        </div>
                                    ))}
                                </div>
                                : null
                                }
                                {otherView?.length>0?
                                <div      
                                    className="popover-data"  
                                    style={{
                                        width: '275px',
                                        overflow: 'auto',
                                        height: '25vh',
                                    }}          
                                    ref={popoverRef}
                                >
                                    <div
                                        style={{
                                            padding: '8px 1px',
                                            color: 'black',
                                            fontWeight: 600,
                                        }}
                                    >Created by Others ({filteredOtherView?.length})</div>
                                    {filteredOtherView && filteredOtherView?.map((datelist)=>(

                                        <div
                                            style={{paddingLeft:'10px', display:'flex', alignItems:'center', justifyContent:'space-between', paddingRight:'8px'}}
                                            className={selectedView==datelist.label? "popoverdataitem popoverdataitem-active": "popoverdataitem"}>
                                            <span style={{flex:1, cursor:'pointer'}} onClick={(e)=>{handelSelectedView(datelist); setOpenDropdownId(null); setViewPop(false); }}>
                                                {datelist.label}  
                                                <div className="view-body-subtitle"> Created By - {datelist?.createdByDetail?.firstname} {datelist?.createdByDetail?.lastname}</div>
                                            </span>
                                            <Dropdown menu={{ items: getStandardViewItems(datelist) }} trigger={["click"]} getPopupContainer={() => document.body} overlayStyle={{ zIndex: 2000 }} open={openDropdownId === datelist._id} onOpenChange={(open) => setOpenDropdownId(open ? datelist._id : null)}>
                                                <span className="link view-option" style={{fontSize:'12px', whiteSpace:'nowrap'}} onClick={(e)=>e.stopPropagation()}>
                                                    Options <CaretDownFilled />
                                                </span>
                                            </Dropdown>
                                        </div>
                                    ))}
                                </div>
                                : null
                                }
                            </div>

                            {/* footer */}
                            <div className="addViewfooter" ref={popoverRef} onClick={()=>{setOpenDropdownId(null);setViewPop(false); setCreateViewForm(true)}}>
                                <span>Create a new view</span>
                            </div>

                        </div>
                        : null
                        }
                        trigger="click"
                        placement='bottom'
                    >
                      <Button type='text' ref={(el) => { popoverRef.current = el; triggerBtnRef.current = el; }} onClick={() => {
                        if (!viewPop && triggerBtnRef.current) {
                          const rect = triggerBtnRef.current.getBoundingClientRect();
                          setPopoverMarginLeft(Math.max(8 - rect.left, 12));
                        }
                        setViewPop(!viewPop);
                      }}> <FontAwesomeIcon icon={faAdd} color='#7c98b6' /> &nbsp; Add view ({items?.length}/5)</Button>
                </Popover>

                {/* <Button type='text' onClick={()=>{setAllViewModal(true); openAllViewAction();}}>All views </Button> */}
              </>
            }

          </div>


      </div>
      
      <CreateView
            visible={createViewForm || togglenewCreateView}
            onClose={()=>{setCreateViewForm(false); dispatch(setTogglenewCreateView(false)); handelActiveTab(sessionStorage.getItem("selectedViewId"))}}
            setcreatedView = {setCreatedView}
            createdView={createdView}
            branchViewRefetch={refetch}
            createView= {createView}
            createViewLoading = {createViewLoading}
            selectedView={viewList?.find((view)=>view._id==sessionStorage.getItem("selectedViewId"))}
      />

      <ViewActionModal
            visible={viewActionModal}
            onClose={()=>{ setActionView(null); setViewActionModal(false); }}
            data={actionView}
            loading={loading}
            updateView={updateView}
            cloneView={cloneView}
            refetch={refetch}
      />

    {
      allViewModal &&
      <AllView 
        objectType={objectType}
        viewList = {viewList}
        loading = {loading}
        refetch = {refetch}
        close={()=>{setAllViewModal(false); closeAllViewAction();}}
        updateView={updateView}
        cloneView={cloneView}
        deleteView={deleteView}
        handelSelectedView={handelSelectedView}
      />
    }


    </>
  );
};


export default React.memo(DraggableTab, (prevProps, nextProps) => {
  return (
    prevProps.viewList === nextProps.viewList &&
    prevProps.objectType === nextProps.objectType &&
    prevProps.loading === nextProps.loading &&
    prevProps.createViewLoading === nextProps.createViewLoading &&
    prevProps.addNewViewHide === nextProps.addNewViewHide
  );
});